<template>
  <card v-if="eventsModel" :widget-model="eventsModel" :has-subtitle="false" title="Patient Events" :has-settings="false" :auto-height="true" maintain-aspect-ratio :key="reloadKey" v-bind="cardAttrs">
    <template #headerUtils>
      <b-field v-if="showFilters" style="margin-bottom: 0;" addons expanded>
        <b-radio-button v-model="eventsModel.params.filter_monitoring" native-value="ai">
          <span>AI</span>
        </b-radio-button>
        <b-radio-button v-model="eventsModel.params.filter_monitoring" native-value="manual">
          <span>Manual</span>
        </b-radio-button>
        <b-radio-button v-model="eventsModel.params.filter_monitoring" native-value="all">
          <span>All</span>
        </b-radio-button>
      </b-field>
      <b-modal v-model="alarmOpen" :component="getAlarmComponent()" :events="{ save: eventSaved }" :props="{ 'monitor_id': widgetModel.monitorId }" :can-cancel="false"></b-modal>
      <button class="button is-primary is-outlined event-button mr-2" @click="newEventClick" v-if="eventsModel?.monitor?.status != 'stopped'">
        <span>New Event</span>
      </button>
      <slot name="headerUtils"></slot>
    </template>
  </card>
</template>

<script>
import Card from "@/components/card/Card";
import Alarm from "@/components/Alarm";
export default {
  name: "EventsCard",
  components: {Card},
  props: {
    widgetModel: {
      type: Object,
    },
    showFilters: {
      type: Boolean,
      default: false
    },
    cardAttrs: {
      type: Object,
      default: () => { return {} }
    },
    handleNewEvent: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    widgetModel: {
      handler(newVal) {
        if (newVal) {
          this.eventsModel = this.widgetModel
        }
      },
      immediate: true
    }
  },
  methods: {
    getAlarmComponent() {
      return Alarm
    },
    eventSaved() {
      this.reloadKey++
    },
    newEventClick() {
      if (this.handleNewEvent) {
        this.$emit('new-event-open')
      } else {
        this.alarmOpen = true
      }
    }
  },
  data() {
    return {
      newEvent: false,
      eventsModel: null,
      alarmOpen: false,
      reloadKey: 0
    }
  }

}
</script>

<style scoped>
.event-button {
  margin-left: 15px;
}
</style>
